import {
  URLBuilder1hwx1b9569i61 as URLBuilder,
  Urlowwyg1lanrqp as Url,
} from '../../../../../ktor-ktor-http/io/ktor/http/URLUtils.mjs';
import {
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Companion_getInstanceudl2ftapa8hy as Companion_getInstance } from '../../../../../ktor-ktor-http/io/ktor/http/URLProtocol.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import {
  Close3tx65evcwi73t as Close,
  Binary3tlzyfojm51s4 as Binary,
  Text3e6ukp9joohql as Text,
} from '../../../../../ktor-ktor-websockets/io/ktor/websocket/Frame.nonJvm.mjs';
import {
  toString1pkumu07cwy4m as toString,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { decodeToString1x4faah2liw2p as decodeToString } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { readText30p9xkeoodw49 as readText } from '../../../../../ktor-ktor-websockets/io/ktor/websocket/FrameCommon.mjs';
import { Plugin_getInstance20jjnf84nf0zp as Plugin_getInstance } from '../../../../../ktor-ktor-client-core/io/ktor/client/plugins/websocket/WebSockets.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  ApolloNetworkException3denf70pfh242 as ApolloNetworkException,
  ApolloWebSocketClosedException26hvn543pf46i as ApolloWebSocketClosedException,
} from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import {
  coroutineScope2qhrb6lhutwsn as coroutineScope,
  CoroutineScopelux7s7zphw7e as CoroutineScope,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { headers24pki7ce1busg as headers } from '../../../../../ktor-ktor-client-core/io/ktor/client/request/HttpRequest.mjs';
import { url1qder21xodqzl as url } from '../../../../../ktor-ktor-client-core/io/ktor/client/request/buildersWithUrl.mjs';
import { webSocket30y01xcxbjfrw as webSocket } from '../../../../../ktor-ktor-client-core/io/ktor/client/plugins/websocket/builders.mjs';
import { CloseReason10cphaqpp3ct7 as CloseReason } from '../../../../../ktor-ktor-websockets/io/ktor/websocket/CloseReason.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Dispatchers_getInstance128lm494a5r5s as Dispatchers_getInstance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Dispatchers.mjs';
import { SupervisorJobythnfxkr3jxc as SupervisorJob } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Supervisor.mjs';
import { Channel3r72atmcithql as Channel } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Channel.mjs';
import { HttpClient3584jcajl7sef as HttpClient } from '../../../../../ktor-ktor-client-core/io/ktor/client/HttpClient.web.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *open($this, url, headers, $completion) {
  // Inline function 'kotlin.apply' call
  var this_0 = URLBuilder(url);
  var tmp0_subject = url.i59_1;
  var tmp;
  if (tmp0_subject.equals(Companion_getInstance().u59_1)) {
    tmp = Companion_getInstance().w59_1;
  } else if (tmp0_subject.equals(Companion_getInstance().t59_1)) {
    tmp = Companion_getInstance().v59_1;
  } else if (tmp0_subject.equals(Companion_getInstance().v59_1) || tmp0_subject.equals(Companion_getInstance().w59_1)) {
    tmp = url.i59_1;
  } else {
    throw UnsupportedOperationException().a1('SOCKS is not a supported protocol');
  }
  this_0.s59(tmp);
  var newUrl = this_0.e3a();
  launch($this.x6f_1, VOID, VOID, KtorWebSocketEngine$open$slambda($this, newUrl, headers));
  return new (KtorWebSocketEngine$open$4())($this);
}
function *closeReasonOrNull($this, $receiver, $completion) {
  var tmp;
  try {
    tmp = yield* $receiver.u5e().qz($completion);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var t = $p;
      if (t instanceof CancellationException()) {
        throw t;
      }
      tmp_0 = null;
    } else {
      throw $p;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function *sendFrames($this, session, $completion) {
  while (true) {
    var frame = yield* $this.z6f_1.z1b($completion);
    yield* session.a5f(frame, $completion);
    if (frame instanceof Close()) {
      $this.y6f_1.i1c();
    }
  }
  return Unit_instance;
}
function *receiveFrames($this, incoming, $completion) {
  while (true) {
    var frame = yield* incoming.z1b($completion);
    if (frame instanceof Text()) {
      $this.y6f_1.x1b(readText(frame));
    } else {
      if (frame instanceof Binary()) {
        $this.y6f_1.x1b(decodeToString(frame.p5e_1));
      } else {
        // Inline function 'kotlin.error' call
        var message = 'unknown frame type';
        throw IllegalStateException().o(toString(message));
      }
    }
  }
  return Unit_instance;
}
function KtorWebSocketEngine$_init_$lambda_2axi3y($this$HttpClient) {
  $this$HttpClient.s5k(Plugin_getInstance());
  return Unit_instance;
}
function KtorWebSocketEngine$open$slambda$slambda$slambda$slambda(this$0, $this_webSocket) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    yield* /*#__NOINLINE__*/sendFrames(this$0, $this_webSocket, $completion);
    return Unit_instance;
  }), 1);
}
function KtorWebSocketEngine$open$slambda$slambda$slambda(this$0, $this_webSocket) {
  return constructCallableReference(($this$coroutineScope, $completion) => orPromise($completion, function *($completion) {
    launch($this$coroutineScope, VOID, VOID, KtorWebSocketEngine$open$slambda$slambda$slambda$slambda(this$0, $this_webSocket));
    var tmp;
    try {
      tmp = yield* /*#__NOINLINE__*/receiveFrames(this$0, $this_webSocket.y5e(), $completion);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        var closeReason = yield* /*#__NOINLINE__*/closeReasonOrNull(this$0, $this_webSocket, $completion);
        var tmp_1;
        if (!(closeReason == null)) {
          tmp_1 = ApolloWebSocketClosedException().t4g(closeReason.e5e_1, closeReason.f5e_1, e);
        } else {
          tmp_1 = ApolloNetworkException().a4a('Web socket communication error', e);
        }
        var apolloException = tmp_1;
        this$0.y6f_1.g1c(apolloException);
        throw e;
      } else {
        throw $p;
      }
    }
    return Unit_instance;
  }), 1);
}
function KtorWebSocketEngine$open$slambda$slambda(this$0) {
  return constructCallableReference(($this$webSocket, $completion) => orPromise($completion, function *($completion) {
    yield* coroutineScope(KtorWebSocketEngine$open$slambda$slambda$slambda(this$0, $this$webSocket), $completion);
    return Unit_instance;
  }), 1);
}
function KtorWebSocketEngine$open$slambda(this$0, $newUrl, $headers) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    try {
      var tmp = ($this$webSocket) => {
        headers($this$webSocket, ($this$headers) => {
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s = $headers.p1();
          while (_iterator__ex2g4s.q1()) {
            var element = _iterator__ex2g4s.r1();
            $this$headers.w4s(element.u4b_1, element.v4b_1);
          }
          return Unit_instance;
        });
        url($this$webSocket, $newUrl);
        return Unit_instance;
      };
      yield* webSocket(this$0.w6f_1, tmp, KtorWebSocketEngine$open$slambda$slambda(this$0), $completion);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        this$0.y6f_1.g1c(ApolloNetworkException().a4a('Web socket communication error', e));
      } else {
        throw $p;
      }
    }
    finally {
      this$0.y6f_1.g1c(ApolloNetworkException().a4a('Web socket communication error', null));
    }
    return Unit_instance;
  }), 1);
}
var KtorWebSocketEngine$open$4Class;
function KtorWebSocketEngine$open$4() {
  if (KtorWebSocketEngine$open$4Class === VOID) {
    class $ {
      constructor(this$0) {
        this.d6g_1 = this$0;
      }
      *g6f($completion) {
        return yield* this.d6g_1.y6f_1.z1b($completion);
      }
      f6f(data) {
        this.d6g_1.z6f_1.x1b(Binary().e5i(true, data.f3y()));
      }
      u6c(string) {
        this.d6g_1.z6f_1.x1b(Text().o5i(string));
      }
      m6() {
        this.d6g_1.z6f_1.x1b(Close().y5f(CloseReason().g5e(1000, '')));
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [0]);
    KtorWebSocketEngine$open$4Class = $;
  }
  return KtorWebSocketEngine$open$4Class;
}
var KtorWebSocketEngineClass;
function KtorWebSocketEngine() {
  if (KtorWebSocketEngineClass === VOID) {
    class $ {
      constructor(client) {
        return new.target.a6g(client);
      }
      static a6g(client) {
        var $this = createThis(this);
        $this.w6f_1 = client;
        $this.x6f_1 = CoroutineScope(Dispatchers_getInstance().b14_1.in(SupervisorJob()));
        $this.y6f_1 = Channel(2147483647);
        $this.z6f_1 = Channel(2147483647);
        return $this;
      }
      static e6g() {
        return this.a6g(HttpClient(KtorWebSocketEngine$_init_$lambda_2axi3y));
      }
      *q6e(url, headers, $completion) {
        return yield* /*#__NOINLINE__*/open(this, Url(url), headers, $completion);
      }
    }
    initMetadataForClass($, 'KtorWebSocketEngine', $.e6g, VOID, VOID, [2, 1]);
    KtorWebSocketEngineClass = $;
  }
  return KtorWebSocketEngineClass;
}
//region block: exports
export {
  KtorWebSocketEngine as KtorWebSocketEngine2cbfnq8i807su,
};
//endregion

//# sourceMappingURL=KtorWebSocketEngine.mjs.map
